<template>
    <!-- 科室成本 -->
    <productSchema :config="config"></productSchema>
</template>

<script>
import { config } from './js/department'
import productSchema from '../common/product_schema.vue'
export default {
    name: '',
    components: { productSchema },
    data() {
        return {
            config: config,
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {

    },
};
</script>

<style scoped lang="less">
.odr {}
</style>
